module.exports = __webpack_public_path__ + "static/media/partnerProposal.af566522.pdf";